import { JSX } from 'react';
import mockScheduleEmpty from 'assets/images/mock-schedule-empty.svg';
import { isMappedGroupSchedule } from 'entities/index';
import { IMappedTeacherSchedule } from 'entities/teachers/types';
import { IMappedGroupSchedule } from 'entities/types';
import {
  CardGroupSchedule,
  CardTeacherSchedule,
} from 'widgets/schedule/stageSchedule/cardSchedule';

export const makeCards = (
  data: IMappedGroupSchedule[] | IMappedTeacherSchedule[],
) => {
  const cards: JSX.Element[] = [];

  data.forEach((item) => {
    if (isMappedGroupSchedule(item)) {
      cards.push(
        <CardGroupSchedule
          data={item as IMappedGroupSchedule}
          key={item.key}
        />,
      );
    } else {
      cards.push(
        <CardTeacherSchedule
          data={item as IMappedTeacherSchedule}
          key={item.key}
        />,
      );
    }
  });

  if (!data.length) {
    cards.push(
      <div
        style={{
          width: '100%',
          marginTop: 15,
        }}
        key={0}
      >
        <img src={mockScheduleEmpty} alt="empty" />
      </div>,
    );
  }
  return cards;
};
